import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {InlineTab} from 'shells/tabs/inline-tabs/inline-tab';
import {InlineTabs} from 'shells/tabs/inline-tabs/inline-tabs';

import {ACTIVITIES, FEED, TODOS} from '../../dashboard-constants';
import type {ActivitiesTabKey, FeedTabKey, TodosTabKey} from '../../dashboard-constants';

import styles from './dashboard-tabs.module.css';

type Props = {
    name: string;
    onChange: (newVal: any) => any;
    activeView: ActivitiesTabKey | FeedTabKey | TodosTabKey;
    includeFeed?: boolean;
    isRequestingActivities?: boolean;
    isRequestingTodos?: boolean;
};

export class DashboardTabs extends React.Component<Props> {
    render() {
        return (
            <InlineTabs
                name={this.props.name}
                selectedTab={this.props.activeView}
                onChange={this.props.onChange}
            >
                <InlineTab value={ACTIVITIES}>
                    <div className={styles['tab-container']}>
                        <span>Activities</span>
                        {this.props.isRequestingActivities ? (
                            <LoadingIcon className={styles.refreshing} size={11} />
                        ) : undefined}
                    </div>
                </InlineTab>
                <InlineTab value={TODOS}>
                    <div className={styles['tab-container']}>
                        {NutClientConfig.hasSalesProcessSetupOverhaulNUT7581 ? (
                            <span>Tasks</span>
                        ) : (
                            <span>To Do</span>
                        )}
                        {this.props.isRequestingTodos ? (
                            <LoadingIcon className={styles.refreshing} size={11} />
                        ) : undefined}
                    </div>
                </InlineTab>
                {this.props.includeFeed ? <InlineTab value={FEED}>Timeline</InlineTab> : undefined}
            </InlineTabs>
        );
    }
}
